<template>
    <div>
        <div class="modal fade" id="singleStudent" tabindex="-1" aria-labelledby="singleStudent" role="dialog" aria-hidden="true">
            <div class="modal-dialog modal-dialog-centered modal-md" role="document">
                <div class="modal-content p-3">
                    <div class="popup-head line-head">
                        <h2 class="pb-3"> Add New Student </h2>
                    </div>
                    <button type="button" class="close" data-dismiss="modal" aria-hidden="true" aria-label="Close">
                        <span>&times;</span>
                    </button>
                    <div class="modal-body p-0">
                        <div class="row">
                            <div class="col-md-6">
                                <div class="form-group">
                                    <input type="text" class="form-control" autocomplete="off" required placeholder="Student ID" v-model="studentForm.student_id"/>
                                    <has-error :form="studentForm" field="student_id"></has-error>
                                </div>
                            </div>
                            <div class="col-md-6">
                                <div class="form-group">
                                    <input type="text" class="form-control" autocomplete="off" required placeholder="Name"  v-model="studentForm.name"/>
                                    <has-error :form="studentForm" field="name"></has-error>
                                </div>                                
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-md-6">
                                <div class="form-group">
                                    <input type="text" class="form-control" autocomplete="off" required placeholder="CNIC"  v-model="studentForm.cnic_number"/>
                                    <has-error :form="studentForm" field="cnic_number"></has-error>
                                </div>
                            </div>
                            <div class="col-md-6">
                                <div class="form-group">
                                    <input type="text" class="form-control" autocomplete="off" required placeholder="Mobile Number"  v-model="studentForm.mobile_number"/>
                                    <has-error :form="studentForm" field="mobile_number"></has-error>
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-md-6">
                                <div class="form-group">
                                    <input type="text" class="form-control" autocomplete="off" required placeholder="Email"  v-model="studentForm.email_address"/>
                                    <has-error :form="studentForm" field="email_address"></has-error>
                                </div>
                            </div>
                        </div>
                        <div class="mt-4 text-right">
                            <button class="btn btn-primary active" @click="addSingleStudent"> Save </button>
                            <button class="btn btn-primary" data-dismiss="modal" aria-hidden="true" aria-label="Close"> Cancel </button>
                        </div>
                    </div>
                </div>
            </div>
        </div> <!-- Need Ateention Modal End -->
        <div class="modal fade" id="bulkupload" tabindex="-1" aria-labelledby="bulkupload" role="dialog" aria-hidden="true">
            <div class="modal-dialog modal-dialog-centered modal-lg" role="document">
                <div class="modal-content p-3">
                    <div class="popup-head line-head">
                        <h2 class="pb-3"> Student/Member Bulk Upload </h2>
                    </div>
                    <button type="button" class="close" data-dismiss="modal" aria-hidden="true" aria-label="Close">
                        <span>&times;</span>
                    </button>
                    <div class="modal-body batch-upload-main collection-student-bulk-upload-popup p-0">
                        <div class="upload-sheet" v-show="previewMapField == false">
                            <label for="" class="label block-label upload-label"> Upload a CSV <i class="fas fa-question-circle" data-toggle="tooltip" data-placement="top" title=".CSV is an Microsoft Excel file format which is a requirement for Payroll Plus to read your file. You can save your Excel file into a .CSV file using 'save as' option listed under file menu on your Excel program."></i></label>
                            <p> You can also download a sample template <a :href="`${$global.aws_base_url}/csv/BulkStudentUpload.csv`">here</a>. </p>
                            <form  method="post" class="box dropzone drozone-label dz-clickable dropzone content mt-4" action="/upload" id="drop" data-toggle="tooltip" data-placement="left" title="<p class='align-left'>Your CSV file must have the following in order to upload employees in bulk: <br/>
                                1. No repetitions of column names.<br/>
                                2. Only add registered SimSim mobile numbers.<br/>
                                3. Mobile numbers (SimSim wallet numbers) must be in the following format: 923XXXXXXXXX.<br/>
                                4. No special characters in the sheet.<br/>
                                5. Set the formatting of the mobile number column to 'number' with zero decimal places.<br/>
                                6. There should be no empty cells in a valid row.<br/>
                                7. Name, Mobile Number, Basic Salary, Gross Salary, Date of Joining, Email Address and Employment Status are required to upload a batch.</p>">
                                <div class="box__input dz-message">
                                    <label class="drozone-label" for="file">
                                        <img  id="uploadIcon" for="file" src="/images/svgs/upload-icon.svg" alt="" class="upload">
                                        <span for="file" class="filename"> Drop your file here </span>
                                    </label>
                                    <label class="uploadedFileName">Drop your file here</label>
                                </div>
                            </form>
                        </div> <!-- upload sheet -->
                        <div class="previewMapField" v-show="previewMapField == true">
                            <div class="mandatory-fields mb-4">
                                <label for="" class="label block-label upload-label mb-3"> Mandatory Information <i class="fas fa-question-circle" data-toggle="tooltip" data-placement="top" title="These fields are required for Payroll Plus to process your sheet."></i> </label>
                                <div class="mandatory-tags">
                                    <div class="mandatory-fields-inner">
                                        <div class="mandatory-field-col"> <span class="map-value" title="Name"> <i v-show="mand_name" class="fas fa-check"></i> Name </span> </div>
                                        <div class="mandatory-field-col"> <span class="map-value" title="Student/Member ID"> <i v-show="mand_studentid" class="fas fa-check"></i> Student/Member ID </span> </div>
                                        <div class="mandatory-field-col"> <span class="map-value" title="CNIC no."> <i v-show="mand_cnicno" class="fas fa-check"></i> CNIC no. </span> </div>
                                        <div class="mandatory-field-col"> <span class="map-value" title="Mobile Number"> <i v-show="mand_mobilenumber" class="fas fa-check"></i> Mobile Number </span> </div>
                                        <div class="mandatory-field-col"> <span class="map-value" title="Email Address"> <i v-show="mand_emailaddress" class="fas fa-check"></i> Email Address </span> </div>
                                    </div>
                                </div>
                            </div>
                            <label for="" class="label block-label upload-label"> Preview and map your identifiers <i class="fas fa-question-circle" data-toggle="tooltip" data-placement="top" title="Please review the below identifiers in line with the columns in your sheet."></i>
                            </label>
                            <p> Please check if we have correctly picked your data. </p>
                            <div class="fields-mapping mt-4" id="fieldmapping_table">
                            </div>
                        </div>
                        <div class="mt-4 text-right">
                            <button type="button" class="btn btn-primary" id="proceedButton">Proceed</button>
                        </div>
                    </div>
                </div>
            </div>
        </div> <!-- Need Ateention Modal End -->
        <div class="page-top mb-1 mb-3" v-bind:class="{clearfix: viewPage}" v-if="viewPage == true">
			<h1 class="float-left mt-2"> Add Students/Members </h1>
			<router-link :to="`/feeAddCampusConfirmation/`+this.$route.params.id" class="btn btn-primary float-right ml-1 active"> Save & Continue </router-link>
			<a href="#" data-toggle="modal" data-target="#bulkupload" class="btn btn-primary float-right ml-1 active"> Bulk Upload </a>
			<a href="#" data-toggle="modal" data-target="#singleStudent" class="btn btn-primary float-right ml-1 active"> Add New </a>
        </div>
        <template v-if="viewPage == null">
            <preLoader></preLoader>
        </template>
        <template v-else-if="students.length == 0">
            <div class="row normal-ib-space">
                <div class="col-md-12">
                    <ul class="page-status collections-page-status align-left pt-0">
                        <li class="page-status-list done">
                            <span class="status-highlighter">1</span>
                            Branch Detail
                        </li>
                        <li class="page-status-list active">
                            <span class="status-highlighter">2</span>
                            Add Students
                        </li>
                        <li class="page-status-list">
                            <span class="status-highlighter">3</span>
                            Confirmation Messgae
                        </li>
                    </ul>
                </div>
            </div>
            <div class="content-box p-5">
                <div class="add-new-branch-content align-center">
                    <img src="/images/add-branch-image.png" alt="" />
                    <p class="mt-3"> You Dont have any students <br/> currently adddes for this branch. <br/> start by adding first </p>
                    <div class="btns-holder mt-4">
                        <button class="btn btn-primary active" data-toggle="modal" data-target="#singleStudent"> Add New </button>
                        <button class="btn btn-primary" data-toggle="modal" data-target="#bulkupload"> Bulk Upload </button>
                    </div>
                </div>
            </div>
        </template>
        <template v-else-if="students.length > 0">
            <hr class="border" />
            <div class="row normal-ib-space align-items-center mb-3">
                <div class="col-md-5"> <input id="customSearch" type="text" class="form-control search" placeholder="Search" title="Search Student by name or id" name="" /> </div>
                <div class="col-md-7">
                    <ul class="page-status text-right border-bottom-0 p-0">
                        <li class="page-status-list done">
                            <span class="status-highlighter">1</span>
                            Branch Detail
                        </li>
                        <li class="page-status-list active">
                            <span class="status-highlighter">2</span>
                            Add Students
                        </li>
                        <li class="page-status-list">
                            <span class="status-highlighter">3</span>
                            Confirmation Messgae
                        </li>
                    </ul>
                </div>
            </div>
		<div class="autogenerate-content">
			<table id="dt-autogenerate-users" class="table" style="width:100%">
		        <thead>
		            <tr>
		            	<th>ID</th>
		            	<th>Name</th>
		                <th>CNIC</th>
		                <th>Mobile</th>
		                <th>Email</th>
		                <th class="text-center">Action</th>
		            </tr>
		        </thead>
		        <tbody>
		            <tr v-for="student in students" :key="student.id">
		            	<td> {{student.student_id}} </td>
		                <td> {{student.name}} </td>
		                <td> {{student.cnic_number}} </td>
		                <td> {{student.mobile_number}} </td>
		                <td> {{student.email_address}} </td>
		                <td class="text-center">
		                	<a @click="deleteStudents(student.id)" data-toggle="tooltip" data-placement="top" title="" class="action text-center" data-original-title="Delete"> <i class="fas fa-trash"></i> </a>
		                </td>
		            </tr>
		        </tbody>
		    </table>
		</div>
            
        </template>
        <template v-else-if="viewPage == false">
            <notAllowed></notAllowed>
        </template>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                studentForm: new Form({
                    campus_id : this.$route.params.id,
                    student_id : '',
                    name : '',
                    cnic_number : '',
                    mobile_number : '',
                    email_address : '',
                }),
                viewPage : null,
                students : [],
                cities : null,
                previewMapField : false,
                fileAdded : false,
                fileRowData : [],
                dropZoneObject : null,
                mand_name : false,
                mand_studentid : false,
                mand_cnicno : false,
                mand_mobilenumber : false,
                mand_emailaddress : false,
                proceedButtonflag : false,
            }
        },
        methods: {
            deleteStudents(id){
                this.$Progress.start();
                axios.get('/api/deleteStudentById/'+id)
                .then(result => {
                    console.log(result);
                    if(result.status == 200){
                        if(result.data.code == 200){
                            this.showToastBox('success','Student has been deleted');
                            this.$router.go();
                        }else{
                            this.showToastBox('error','Error in deleting student');
                        }
                    }
                    this.$Progress.finish();
                })
                .catch(error => {
                    this.$Progress.fail();
                });
            },
            handleGeneratePayrollButton(){
                if(this.fileAdded == true){
                    $('a#payroll_proceed_top,a#payroll_proceed_bottom').removeAttr('disabled','disabled').addClass('active');
                    if(this.isAPIAvailable()){
                        $.when(this.printTable(this.dropZoneObject.files[0]));
                    }
                }else{
                    $('a#payroll_proceed_top,a#payroll_proceed_bottom').attr('disabled','disabled').removeClass('active');
                }
            },
            initDropZone() {
                var that = this;
                Dropzone.options.drop = {
                    addRemoveLinks: true,
                    paramName: 'file',
                    maxFilesize: 2, // MB
                    uploadMultiple: false,
                    maxFiles: 1,
                    minFiles: 1,
                    queueLimit:1,
                    url: that.$global.base_url+'api/feeStudentsBulkUploadFile',
                    acceptedFiles: '.csv',
                    autoProcessQueue:false,
                    headers: window.axios.defaults.headers.common,
                    init: function(){
                        var _this = this;
                        that.dropZoneObject = this;
                        this.on("maxfilesexceeded", function(file) {
                            this.removeAllFiles();
                            this.addFile(file);
                        });
                        this.on('removedfile',function(file){
                            that.fileAdded = false;
                            $('div.box__input').show();
                        }),
                        this.on("addedfile", function(file) {
                            that.fileAdded = true;
                            that.checkFileForErrors(file);
                            that.handleGeneratePayrollButton();
                        });
                        var popupProcessButton 	= document.querySelector("#proceedButton");
                        function processFileLocal(){
                            if(that.isAPIAvailable()){
                                $.when(that.printTable(that.dropZoneObject.files[0]));
                            }
                        }
                        function processQueueLocal(){
                            that.dropZoneObject.processQueue(); // Tell Dropzone to process all queued files.
                        }
                        popupProcessButton.addEventListener("click", function(e) {
                            processQueueLocal();
                        });
                        that.dropZoneObject.on("sending", function(file, xhr, formData) {
                            that.$Progress.start();
                            formData.append("campus_id", that.$route.params.id);
                            formData.append("filesize", file.size);
                            var mapIdentifier = [];
                            var selVal = '';
                            $( "select.selectpicker" ).each(function() {
                                selVal = $(this).find('option:selected').val();
                                mapIdentifier.push(selVal);
                                selVal = '';
                            });
                            formData.append("mapIdentifier", JSON.stringify(mapIdentifier));
                            formData.append("_token",$('meta[name="csrf-token"]').attr('content'));
                        });

                        that.dropZoneObject.on("totaluploadprogress", function(progress) {

                        });

                        that.dropZoneObject.on("uploadprogress", function(file, progress, bytesSent) {
                            // Update progress bar with the value in the variable "progress", which
                            // is the % total upload progress from 0 to 100
                            console.log(progress);
                            var progressBar = Math.floor(progress);
                            if(progressBar == 100){
                                that.$Progress.finish();
                            }
                        });

                        that.dropZoneObject.on("success", function(file, obj) {
                            if(obj.code == "200") {
                                that.showToastBox('success','File has been uploaded');
                                that.$router.go();
                            }else{
                                that.showAlertBox('error','Error in file',msg);
                            }
                        });
                        that.dropZoneObject.on('error',function(file,errorMessage,xhr){
                            if(!file.accepted){
                                fileAdded = false;
                                that.showAlertBox('error','Error in file');
                                this.removeFile(file);
                            }
                            var msg = 'Error:'+xhr.status+' '+xhr.statusText;
                            that.showAlertBox('error','Error in file', msg);
                            file.status = Dropzone.QUEUED;
                        });
                    }
                };
                $('.cross').on('click', function(e){
                    that.dropZoneObject.removeAllFiles();
                    $('label.uploadedFileName').html('Drop your file here');
                });
            },
            isAPIAvailable() {
                // Check for the various File API support.
                if (window.File && window.FileReader && window.FileList && window.Blob) {
                    // Great success! All the File APIs are supported.
                    return true;
                } else {
                    var error_message = 'The HTML5 APIs used in this form are only available in the following browsers:<br /> - Google Chrome: 13.0 or later<br /> - Mozilla Firefox: 6.0 or later<br /> - Internet Explorer: Not supported (partial support expected in 10.0)<br /> - Safari: Not supported<br /> - Opera: Not supported';
                    this.showAlertBox('error',error_message);
                    return false;
                }
            },
            printTable(file) {
                var reader = new FileReader();
                reader.readAsText(file);
                var that = this;
                reader.onload = function(event){
                    var csv = event.target.result;
                    var data = $.csv.toArrays(csv);
                    for(var row in data){
                        if(row > 0){
                            var _row = [];
                            for(var item in data[row]){
                                var value = data[row][item];
                                _row.push(value);
                            }
                            that.fileRowData.push(_row);
                        }
                    }
                    var test 		= '';
                    var selected 	= '';
                    var col = [];
                    for(var row in data) {
                        if(row > 1) break;
                        for(var item in data[row]) {
                            if(row == 0){
                                col[item] = [data[row][item]];
                            }else{
                                col[item].push(data[row][item]);
                            }
                        }
                    }
                    for(var row1 in col) {
                        var rowName = '';
                        var rowValue = '';
                        var comboBox = '';
                        var fieldMap = false;
                        for(var item1 in col[row1]) {
                            if(item1 > 1){ break; }
                            if(item1 == 0){
                                rowName = col[row1][item1];
                            }else{
                                rowValue += '<p>' + col[row1][item1] + '</p>';
                            }
                        }
                        // check for if you find the Name in you ddList
                        if(rowName.trim().toLocaleLowerCase() == 'name'){
                            that.mand_name = fieldMap = true;
                        }
                        if(rowName.trim().toLocaleLowerCase() == 'student id'){
                            that.mand_studentid = fieldMap = true;
                        }
                        if(rowName.trim().toLocaleLowerCase() == 'cnic no'){
                            that.mand_cnicno = fieldMap = true;
                        }
                        if(rowName.trim().toLocaleLowerCase() == 'mobile number'){
                            that.mand_mobilenumber = fieldMap = true;
                        }
                        if(rowName.trim().toLocaleLowerCase() == 'email address'){
                            that.mand_emailaddress = fieldMap = true;
                        }
                        comboBox += '<select name="'+row1+'" class="selectpicker show-menu-arrow custom-select2" data-size="5">';
                        comboBox += '<option value="do-not"> - Select - </option>';
                        comboBox += '<optgroup label="Student Detail">';
                        selected = (rowName.trim().toLocaleLowerCase() == 'name') ? 'selected' : '';
                        fieldMap = (rowName.trim().toLocaleLowerCase() == 'name') ? true : fieldMap;
                        comboBox += '<option value="Name" '+selected+'>Name</option>';
                        selected = (rowName.trim().toLocaleLowerCase() == 'student id') ? 'selected' : '';
                        fieldMap = (rowName.trim().toLocaleLowerCase() == 'student id') ? true : fieldMap;
                        comboBox += '<option value="Student Id" '+selected+'>Student/Member Id</option>';
                        selected = (rowName.trim().toLocaleLowerCase() == 'cnic no') ? 'selected' : '';
                        fieldMap = (rowName.trim().toLocaleLowerCase() == 'cnic no') ? true : fieldMap;
                        comboBox += '<option value="CNIC no." '+selected+'>CNIC no.</option>';
                        selected = (rowName.trim().toLocaleLowerCase() == 'mobile number') ? 'selected' : '';
                        fieldMap = (rowName.trim().toLocaleLowerCase() == 'mobile number') ? true : fieldMap;
                        comboBox += '<option value="Mobile Number" '+selected+'>Mobile Number</option>';
                        selected = (rowName.trim().toLocaleLowerCase() == 'email address') ? 'selected' : '';
                        fieldMap = (rowName.trim().toLocaleLowerCase() == 'email address') ? true : fieldMap;
                        comboBox += '<option value="Email Address" '+selected+'>Email Address</option>';
                        comboBox += '</optgroup>';
                        comboBox += '</select>';
                        if(fieldMap == true){
                            test += '<div class="row mapped align-items-center">';
                        }else{
                            test += '<div class="row align-items-center">';
                        }
                        test += '<div class="col-md-1"><div class="fields-mapping-inner"><i class="fas fa-check-circle"></i></div></div>';
                        test += '<div class="col-md-7"><div class="fields-mapping-inner"><p> '+rowName+' </p><p> '+rowValue+' </p></div></div>';
                        test += '<div class="col-md-4"><div class="fields-mapping-inner">';
                        test += comboBox;
                        test += '</div></div>';
                        test += '</div>';
                    }
                    $('#fieldmapping_table').html(test);
                    that.previewMapField = true;
                    that.generateButtonProccess();
                    $('select.selectpicker').selectpicker('refresh');
                    that.assignComboFunction();
                };
                reader.onerror = function(){ this.showAlertBox('error','Unable to read ' + file.fileName); }.bind(this);
            },
            generateButtonProccess(){
                if(this.mand_name == true && this.mand_studentid == true && this.mand_cnicno == true && this.mand_mobilenumber == true && this.mand_emailaddress == true){
                    this.proceedButtonflag = true;
                }else{
                    this.proceedButtonflag = false;
                }
            },
            checkForMandField(){
                $( "select.selectpicker" ).each(function() {
                    this.mand_name = this.mand_studentid = this.mand_name = this.mand_cnicno = this.mand_mobilenumber = this.mand_emailaddress = false;
                    var selVal = $(this).find('option:selected').val();
                    if(selVal.trim().toLowerCase() == 'name') this.mand_name = true;
                    if(selVal.trim().toLowerCase() == 'student id') this.mand_studentid = true;
                    if(selVal.trim().toLowerCase() == 'name') this.mand_name = true;
                    if(selVal.trim().toLowerCase() == 'cnic no.') this.mand_cnicno = true;
                    if(selVal.trim().toLowerCase() == 'mobile number') this.mand_mobilenumber = true;
                    if(selVal.trim().toLowerCase() == 'emailaddress') this.mand_emailaddress = true;
                });
            },
            assignComboFunction(){
                var that = this;
                // Auto Mapped value make disabled
                $('select.selectpicker').each(function(index,obj){
                    $('select.selectpicker option[value="'+obj.value+'"]').attr('disabled',true);
                });
                $(that.$el).find('.selectpicker').selectpicker('refresh');
                var previous;
                $('select.selectpicker').on('shown.bs.select',function(){
                    previous = this.value;
                }).change(function(){
                    var selVal = $(this).find('option:selected').val();
                    $('select.selectpicker option[value="'+previous+'"]').attr('disabled',false);
                    //hide the department, branch and city field sets if deselect
                    $('select.selectpicker option[value="'+selVal+'"]').attr('disabled',true);
                    $(that.$el).find('.selectpicker').selectpicker('refresh');

                    var flag = false;
                    that.checkForMandField();
                    if(selVal.trim().toLowerCase() == 'name') that.mand_name = true;
                    if(selVal.trim().toLowerCase() == 'student id') that.mand_studentid = true;
                    if(selVal.trim().toLowerCase() == 'cnic no.') that.mand_cnicno = true;
                    if(selVal.trim().toLowerCase() == 'mobile number') that.mand_mobilenumber = true;
                    if(selVal.trim().toLowerCase() == 'email address') that.mand_emailaddress = true;

                    that.generateButtonProccess();
                });
            },
            customCombo(){
                // for c-val-displayer start
                $(".cstm-cmbx-w-adtn .c-val-displayer").unbind('click').click(function(){
                    var ref = $(this);
                    var popDiv =  $(this).parent().find(".val-overlyr");
                    var popper = new Popper(ref,popDiv,{
                        placement:'bottom-end',
                        gpuAcceleration:false
                    });
                    $(this).parent().find(".val-overlyr").toggleClass("activated");
                });
                // for c-val-displayer end
            },
            checkFileForErrors(file){
                var reader = new FileReader();
                reader.readAsText(file);
                var that = this;
                reader.onload = function(event){
                    var csv = event.target.result;
                    var data = $.csv.toArrays(csv);
                    var col = [];
                    var duplicate = false;
                    var column = false;
                    var duplicateArray = [];
                    for(var row in data) {
                        if(row == 0){
                            for(var item in data[row]) {
                                var value = data[row][item];
                                value = value.replace(/[^\w\s]/gi,'');
                                if(col.indexOf(value) > -1){
                                    duplicate = true;
                                    duplicateArray.push(value);
                                }
                                col.push(value);
                            }
                        }else{
                            break;
                        }
                    }
                    if(duplicate == true && that.fileAdded == true){
                        var error_message = $('div#duplicatemessage').html() + duplicateArray.toString();
                        that.showAlertBox('error','Duplicate column name',error_message);
                    }
                    if(col.length < 3 && that.fileAdded == true){
                        column = true;
                        var error_message = $('div#columnfourmessage').html();
                        that.showAlertBox('error','Missing column',error_message);
                    }
                    if(duplicate == true || column == true){
                        that.dropZoneObject.removeAllFiles();
                    }
                };
                reader.onerror = function(){ this.showAlertBox('Unable to read ' + file.fileName); }.bind(this);
            },
            addSingleStudent() {
                this.$Progress.start();
                this.studentForm.post('/api/feeAddStudent')
                .then(res => {
                  if(res.status=200){
                    if(res.data.code == 400 ){
                      this.$Progress.fail();
                      this.showAlertBox('error',res.data.msg);
                    }else{
                      this.$Progress.finish();
                      this.showToastBox('success','Student created successfully');
                      this.$router.go();
                    }
                  }else{
                    this.$Progress.fail();
                    this.showAlertBox('error','Some error in your form data');
                  }
                })
                .catch(err => {
                    console.log(err);
                    this.$Progress.fail();
                    this.showAlertBox('error','Some problem in you form data');
                    $(this.$el).find('.selectpicker').selectpicker('refresh');
                });
            },
            getStudentsByCampusId() {
                this.$Progress.start();
                axios.get('/api/getStudentsByCampusId/'+this.$route.params.id)
                .then(result => {
                    this.viewPage = result.data.viewPage;
                    if(result.data.viewPage == true){
                        this.students = result.data.students;
                    }
                    this.$Progress.finish();
                })
                .then(result => {
                    var completeTable = $('#dt-autogenerate-users').DataTable({
                        "sDom": '<"row view-filter"<"clearfix">><"table-holder mb-3"t><"row view-pager"<"col-sm-4 text-left"i"><"col-sm-4 text-center"p"><"col-sm-4 text-right"l>>',
                        "searching":true,
                        columnDefs: [ {
                            orderable: false,
                        }]
                    });
                    $('#customSearch').on( 'keyup', function () {
                        completeTable.search( this.value ).draw();
                    });
                })
                .catch(error => {
                    console.log(error);
                    this.showAlertBox('error','Something went wrong');
                    this.$Progress.fail();
                });
            }
        },
        mounted(){
            var that = this;
            this.getStudentsByCampusId();
            this.initDropZone();
            $(".drozone-label").tooltip({
                html	: true,
                template: '<div class="tooltip" role="tooltip"><div class="tooltip-arrow"></div><div class="tooltip-inner large"></div></div>',
            });
            $("#drop").dropzone();
            $(window.document).on('show.bs.modal', '.modal', function (event) {
                var zIndex = 1040 + (10 * $('.modal:visible').length);
                $(this).css('z-index', zIndex);
                setTimeout(function() {
                    $('.modal-backdrop').not('.modal-stack').css('z-index', zIndex - 1).addClass('modal-stack');
                }, 0);
            });
        },
        created() {
        },
    }
</script>
